// 商品描述

interface Props {
    shortDesc?: string;
}

const ItemDesc = ({ shortDesc }: Props) => {
    return (
        <h3 className="max-w-full whitespace-pre-wrap wrap-break-word text-black8 text-btn1 leading-[150%] lg:line-clamp-5">
            {shortDesc}
        </h3>
    );
};

export default ItemDesc;
